import { computePayable, formatChargeINR } from "../utils/paymentCharges";

/**
 * Checkout tax/fee lines: base, GST 18%, platform fee 2%, GST on fee, total.
 */
const PaymentBreakdown = ({
  base,
  creditLabel = "Amount",
  compact = false,
}) => {
  const amt = Number(base);
  if (!Number.isFinite(amt) || amt <= 0) return null;
  const c = computePayable(amt);

  return (
    <div className={`pay-breakdown${compact ? " compact" : ""}`}>
      <div>
        <span>{creditLabel}</span>
        <b>₹{formatChargeINR(c.base)}</b>
      </div>
      <div>
        <span>GST (18%)</span>
        <b>₹{formatChargeINR(c.gstOnBase)}</b>
      </div>
      <div>
        <span>Platform fee (2%)</span>
        <b>₹{formatChargeINR(c.platformFee)}</b>
      </div>
      <div>
        <span>GST on platform fee (18%)</span>
        <b>₹{formatChargeINR(c.gstOnFee)}</b>
      </div>
      <div className="total">
        <span>You pay</span>
        <b>₹{formatChargeINR(c.total)}</b>
      </div>
    </div>
  );
};

export default PaymentBreakdown;
